// MxTcVideo
import { handleTraceVideo } from '@/utils/trace.js'
export default {
  data () {
    return {
      videoTimer: {},
      videoPlayer: {},
      videoMap: []
    }
  },
  methods: {
    initVideo (id, videoData) {
      const { vodFileId, appId, psign, title, videoId, ...playerData } = videoData || {}
      videoData.title = decodeURIComponent(videoData.title)
      const playerOpts = {
        fileID: vodFileId, // 请传入需要播放的视频 fileID（必须）
        appID: appId, // 请传入点播账号的 appID（必须）
        psign: psign,
        licenseUrl: 'https://1307224350.trtcube-license.cn/license/v2/1307224350_1/v_cube.license',
        ...playerData
      }
      let idOptions = {
        app_Play_Id: new Date().getTime() + '' + Math.round(Math.random() * 999) + 1, // 播放ID（类型：String，长度16位，唯一）
        app_Id: 'IEP', // 应用ID（类型：String，也可叫做渠道ID如：wechat）
        user_Id: Math.round(Math.random() * 999) + 1, // this.userInfo.id, // 用户ID（类型：Number，调用方系统里的用户ID）
        video_Id: vodFileId// 视频ID（类型：Number，调用方系统里的视频ID）
      }
      let videoTitle = videoData.title
      let fileId = videoId
      const player = window.acPlayerToolInit(
        id,
        playerOpts,
        idOptions,
        this.userInfo,
        videoTitle,
        0,
        fileId
      )
      this.initVideoEvent(player, videoData)
    },
    initVideoEvent (player, videoData) {
      const rd = Math.floor(Math.random() * 10 + 1)
      const marking = `${new Date().valueOf()}${rd}`
      player.player.marking = marking
      this.videoPlayer[marking] = player
      this.videoMap[marking] = videoData
      player.player.on('play', this.onPlay)
      player.player.on('pause', this.onPause)
      player.player.on('ended', this.onEnded)
    },
    onPlay (evt) {
      let player = evt.target.player
      let marking = player.marking
      if (marking) {
        for (let key in this.videoPlayer) {
          let player = this.videoPlayer[key].player
          if (key !== marking && !player.paused()) {
            player.pause()
          }
        }
        this.startVideoTimer(marking)
      }
    },
    onPause (evt) {
      let player = evt.target.player
      let marking = player.marking
      if (marking) {
        this.endVideoTimer(marking)
      }
    },
    onEnded (evt) {
      let player = evt.target.player
      let marking = player.marking
      if (marking) {
        if (this.videoMap[marking]) {
          this.videoMap[marking].duration = Math.round(Math.random() * 5)
          handleTraceVideo(this.videoMap[marking])
        }
        this.endVideoTimer(marking)
      }
    },
    startVideoTimer (marking) {
      this.endVideoTimer(marking)
      this.videoTimer[marking] = setTimeout(async () => {
        let player = this.videoPlayer[marking]
        if (this.videoTimer[marking] && player.idOptions.video_Id) {
          this.videoMap[marking].duration = 5
          this.videoMap[marking].baseId = this.$route.query.id
          await handleTraceVideo(this.videoMap[marking])
          this.startVideoTimer(marking)
        }
      }, 1000 * 5)
    },
    endVideoTimer (marking) {
      if (!this.videoTimer[marking]) return
      clearTimeout(this.videoTimer[marking])
      this.videoTimer[marking] = null
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/article/MxTcVideo.js